"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541714/img/image_fy0972xg.png)]">
      {}
      <div className="absolute inset-0 bg-dark-background/40"></div>

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-semibold text-white mb-6 tracking-tight">
          Prime Laundry
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-8 font-sans">
          A modern self-service laundromat concept designed for operational excellence and long-term sustainability in Spartanburg, South Carolina.
        </p>
        <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover shadow-medium">
          <Link to="#about-prime-laundry">Learn More</Link>
        </Button>
      </div>
    </section>;
}